<template>
	<prism-editor class="code-editor m-0 p-0" v-model="code" :highlight="highlighter" :line-numbers="lineNumbers" :readonly="readonly" @input="change"></prism-editor>
</template>

<script>
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-sql'

// import syntax highlighting styles
// import 'prismjs/themes/prism.css'
// import 'prismjs/themes/prism-coy.css
// import 'prismjs/themes/prism-dark.css'
// import 'prismjs/themes/prism-okaidia.css'
// import 'prismjs/themes/prism-solarizedlight.css'
// import 'prismjs/themes/prism-tomorrow.css'
// import 'prismjs/themes/prism-twilight.css'
import 'prismjs/themes/prism-eclipse.css'

export default {
  name: 'd-code-editor',
  props: {
    value: String,
    lineNumbers: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      code: null
    }
  },
  mounted: function () {
    this.code = this.value
  },
  methods: {
    highlighter (code) {
      // languages.<insert language> to return html with markup
      return highlight(code, languages.sql)
    },
    change () {
      this.$emit('input', this.code)
      this.$emit('change', this.code)
    }
  },
  watch: {
    value: function (val) {
      this.code = this.value
    }
  }
}
</script>

<style>
.code-editor-container {
	overflow:auto;
}
/* required class */
.code-editor {
	/* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
	/* you must provide font-family font-size line-height. Example: */
	font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
	font-size: 14px;
	line-height: 1.5;
	padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
	outline: none;
}
.prism-editor-wrapper .prism-editor__line-numbers {
	background-color:lightgray!important;
	padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// CodeEditor.vue?31c205db